import { put, takeLatest, call } from "redux-saga/effects";
import {
	getListPopupAsync,
	setListPopup,
	setDetailPopup,
	GetListPopupPayload,
	updatePopupAsync,
	getDetailPopupAsync,
	createPopupAsync,
	GetDetailPopupPayload,
	CreatePopupPayload,
	UpdatePopupPayload,
	DeletePopupPayload,
	deletePopupAsync,
} from "./popup.slice";
import { message } from "antd";
import api from "service/apiService";
import { t } from "@lingui/macro";
import { translate } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";
import { setLoadingPage } from "store/app/app.slice";

function* getListPopupSaga(action: PayloadAction<GetListPopupPayload>) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get("/dashboard/popups", query);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setListPopup.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetListPopup() {
	yield takeLatest(getListPopupAsync, getListPopupSaga);
}

function* updatePopupSaga(action: PayloadAction<UpdatePopupPayload>) {
	yield put({ type: setLoadingPage.type, payload: true });
	const { id, data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.put(`/dashboard/popups/${id}`, data);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(t`Update successful`);
	} else {
		message.error(translate(error.message));
	}
	yield put({ type: setLoadingPage.type, payload: false });
}
function* watchUpdatePopup() {
	yield takeLatest(updatePopupAsync, updatePopupSaga);
}

function* getDetailPopupSaga(action: PayloadAction<GetDetailPopupPayload>) {
	const { id } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get(`/dashboard/popups/${id}`);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setDetailPopup.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetDetailPopup() {
	yield takeLatest(getDetailPopupAsync, getDetailPopupSaga);
}

function* createPopupSaga(action: PayloadAction<CreatePopupPayload>) {
	yield put({ type: setLoadingPage.type, payload: true });
	const { data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.post("/dashboard/popups", data);

			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(t`Create successful`);
	} else {
		message.error(translate(error.message));
	}
	yield put({ type: setLoadingPage.type, payload: false });
}
function* watchCreatePopup() {
	yield takeLatest(createPopupAsync, createPopupSaga);
}

function* deletePopupSaga(action: PayloadAction<DeletePopupPayload>) {
	yield put({ type: setLoadingPage.type, payload: true });
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.delete("/dashboard/popups/" + id);

			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(t`Delete successful`);
	} else {
		message.error(translate(error.message));
	}
	yield put({ type: setLoadingPage.type, payload: false });
}
function* watchDeletePopup() {
	yield takeLatest(deletePopupAsync, deletePopupSaga);
}

const popupSaga = [
	watchGetListPopup(),
	watchUpdatePopup(),
	watchGetDetailPopup(),
	watchCreatePopup(),
	watchDeletePopup(),
];
export default popupSaga;
